import { formatAsReadonlyPhone, parsePhoneNumber } from '@galaxy/crm/static';
import { Participant } from '@vendasta/conversation';
import { INVALID_CONTACT_NAMES } from './inbox.constants';

export interface ResolveParticipantTitleOptions {
  /** Fall back to the raw internalParticipantId when name, phone, and email are all unavailable. */
  idFallback?: boolean;
}

/**
 * Resolves a participant's display title: name -> formatted phone -> email ->
 * raw phone (if libphonenumber couldn't format it), with the raw
 * internalParticipantId available as a true last resort via idFallback.
 */
export function resolveParticipantTitle(
  recipient: Participant,
  options: ResolveParticipantTitleOptions = {},
): string {
  if (!INVALID_CONTACT_NAMES.includes(recipient?.name)) {
    return recipient.name;
  }

  const parsedPhoneNumber = recipient?.phoneNumber ? parsePhoneNumber(recipient.phoneNumber) : null;
  const phoneNumber = parsedPhoneNumber ? formatAsReadonlyPhone(parsedPhoneNumber) : '';
  if (phoneNumber) {
    return phoneNumber;
  }

  if (recipient?.email) {
    return recipient.email;
  }

  // formatAsReadonlyPhone returns '' when libphonenumber can't parse the number;
  // an unformattable-but-present phone number still beats the raw id.
  if (recipient?.phoneNumber) {
    return recipient.phoneNumber;
  }

  return options.idFallback ? recipient?.internalParticipantId : '';
}
